import PostHog from './posthog';

const eventComponents = new Set([
  'newuser',
  'existinguser',
  'declinedonreapply',
  'declined',
  'pending',
  'terms',
  'termspaynowoffered',
  'termspaynowselected',
  'termspaynowcontinue',
  'termspaynowoutcome',
  'equifaxallowaccess',
]);

export const captureCheckoutEvent = (
  component,
  {
    application,
    company = {},
    merchant = {},
    session = {},
    shopping_cart = {},
    user,
  } = {},
  extra = {}
) => {
  const normalizedComponent =
    typeof component === 'string' ? component.toLowerCase() : '';
  if (!eventComponents.has(normalizedComponent)) return undefined;

  const posthog = new PostHog();
  if (user?.id) {
    posthog.identify({ application, company, merchant, session, user });
  } else {
    posthog.resetStaleIdentity();
  }
  const orderAmount = session.hasShoppingCart?.()
    ? shopping_cart.grand_total
    : '';
  const declineProperties = {
    fico: company.applicant_fico_score,
    underwritingStatus: company.underwriting_status,
    tier: company.tier,
    tcl: company?.credit_line?.get('amount') || 0,
    reason: company.short_display,
  };

  switch (normalizedComponent) {
    case 'termspaynowoffered':
    case 'termspaynowselected':
    case 'termspaynowcontinue':
    case 'termspaynowoutcome':
      return posthog.capture(
        {
          termspaynowoffered: 'Terms PayNow Offered',
          termspaynowselected: 'Terms PayNow Selected',
          termspaynowcontinue: 'Terms PayNow Continue',
          termspaynowoutcome: 'Terms PayNow Outcome',
        }[normalizedComponent],
        {
          sessionType: session.session_type,
          orderAmount,
          merchantPublicKey: merchant.public_key,
          merchantName: merchant.name,
          tier: company.tier,
          underwritingStatus: company.underwriting_status,
          ...extra,
        }
      );
    case 'newuser':
      return posthog.capture('New User', {
        orderAmount,
        merchantPublicKey: merchant.public_key,
        merchantName: merchant.name,
        sessionType: session.session_type,
      });
    case 'existinguser':
      return posthog.capture('Existing User', {
        orderAmount,
        merchantPublicKey: merchant.public_key,
        merchantName: merchant.name,
        sessionType: session.session_type,
      });
    case 'declinedonreapply':
      return posthog.capture('Declined on Reapply', declineProperties);
    case 'declined':
      return posthog.capture('Decline', declineProperties);
    case 'pending':
      return posthog.capture('Pend', declineProperties);
    case 'terms':
      return posthog.capture('Terms', {
        sessionType: session.session_type,
        fico: company.applicant_fico_score,
        orderAmount,
        underwritingStatus: company.underwriting_status,
        tier: company.tier,
        tcl: company?.credit_line?.get('amount') || 0,
        reason: company.short_display,
      });
    case 'equifaxallowaccess':
      return posthog.capture('Equifax Frozen File Displayed', {
        companyId: company.id,
        companyName: company.name,
      });
    default:
      return undefined;
  }
};
